import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=6c82f36e&scoped=true&"
import script from "./Crm.ts?vue&type=script&lang=ts&"
export * from "./Crm.ts?vue&type=script&lang=ts&"
import style0 from "./Crm.vue?vue&type=style&index=0&id=6c82f36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c82f36e",
  null
  
)

export default component.exports